export default __webpack_public_path__ + "static/media/popup-mobile.2f942c27.svg";